export default "__VITE_ASSET__C3z9nblc__"